import React from 'react'
import TagsModal from "./TagsModal";
import {TagsTableViewViewModel} from './TagsTableViewViewModel';
import MUIDataTable from "mui-datatables";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Tooltip from '@mui/material/Tooltip'
import {IconButton} from "@material-ui/core";
import '../views/css/Tags.scss'

class TagsTable extends React.Component {
    constructor() {
        super()
        this.state = {
            isModalOpen: false,
            modalType: '',
            row: {},
        };
    }

    handleCloseModal() {
        this.setState({isModalOpen: false})
    }

    render() {
        const styleIcons = {color: "#df6626"}
        const rows = this.props.data.map((obj) => {
            return {
                id: obj.id_number,
                url: obj.url,
                name: obj.name,
                utmMedium: obj.utmMedium,
                utmSource: obj.utmSource,
                utmCampaign: obj.utmCampaign,
                action: [
                    <Tooltip title="Edit">
                        <IconButton onClick={() => this.setState({isModalOpen: true, modalType: "edit", row: obj})}>
                            <EditIcon style={styleIcons} />
                        </IconButton>
                    </Tooltip>,
                    <Tooltip title="Delete">
                        <IconButton onClick={() => this.setState({isModalOpen: true, row: obj, modalType: 'delete'})}>
                            <DeleteOutlineIcon style={styleIcons} />
                        </IconButton>
                    </Tooltip>,
                ],
            };
        });

        const columns = [
            {
                label: "ID Number",
                name: "id",
                options: {
                    sort: false,
                    display: false,
                },
            },
            {
                label: "Name",
                name: "name",
                options: {
                    sort: false,
                },
            },
            {
                label: "URL",
                name: "url",
                options: {
                    sort: false,
                },
            },
            {
                label: "Medium",
                name: "utmMedium",
                options: {
                    sort: false,
                },
            },
            {
                label: "Source",
                name: "utmSource",
                options: {
                    sort: false,
                },
            },
            {
                label: "Campaign",
                name: "utmCampaign",
                options: {
                    sort: false,
                },
            },
            {
                label: "Actions",
                name: "action",
                options: {
                    sort: false,
                },
            },
        ];

        const TagsTableViewModel = new TagsTableViewViewModel(this.props, this.state)
        const tagsDisabledClass = TagsTableViewModel.tagsDisabledClass();
        const message = TagsTableViewModel.message();

        const options = {
            filter: false,
            selectableRows: "none",
            selectableRowsOnClick: false,
            print: false,
            download: false,
            viewColumns: false,
            search: false,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20, 30, 50, 100, 150, 200],
            textLabels: {
                body: {
                    noMatch: message
                },
            }
        };

        const addBtn = <button className='tags-add-button' variant="contained"
            onClick={() => this.setState({isModalOpen: true, modalType: 'create'})}>
            Add Configuration <span className="tags-add-icon">+</span>
        </button>
        const cancelBtn = <button className='tags-cancel-button' variant="contained" onClick={() => this.handleCloseModal()}>CANCEL</button>

        return (this.state.modalType !== 'delete' && this.state.isModalOpen) ?
            <TagsModal cancelBtn={cancelBtn} handleCloseModal={this.handleCloseModal.bind(this)}
                saveRequest={this.props.saveRequest} modalType={this.state.modalType} row={this.state.row} /> :
            <div>
                {(this.state.modalType === 'delete' && this.state.isModalOpen) &&
                    <TagsModal cancelBtn={cancelBtn}
                        handleCloseModal={this.handleCloseModal.bind(this)} saveRequest={this.props.saveRequest}
                        modalType={this.state.modalType} row={this.state.row} />}
                <div className={`${tagsDisabledClass}`}>
                    <div
                        className="w-full sm:w-1/1 w-1/6 mr-3 mb-3 p-6 bg-white border rounded shadow h-full domain-list-wrap w-full pr-6 mt-6">
                        <div className="tags-title">Tag Configurations</div>
                        <div className="add-button">
                            {addBtn}
                        </div>
                        <div className="domain-list-table">
                            <MUIDataTable
                                data={rows}
                                columns={columns}
                                options={options}
                            />
                        </div>
                    </div>
                </div>
            </div>
    }
}

export default TagsTable

